(function () {
  /**
   * 1. AJAX Cart Drawer Update
   * Refreshes the cart UI without a page reload.
   */
  async function updateCartDrawer() {
    try {
      const fetchResponse = await fetch(window.location.href);
      if (!fetchResponse.ok) throw new Error('Cart fetch failed');
      
      const fetchedHtmlContent = await fetchResponse.text();
      const htmlParser = new DOMParser();
      const parsedDocument = htmlParser.parseFromString(fetchedHtmlContent, 'text/html');
      
      const cartDrawerHtml = parsedDocument.getElementById('Cart-Drawer');
      const cartDrawerToggleHtml = parsedDocument.getElementById('cart-drawer-toggle');
      const addToCartBtn = document.getElementById('cross_addToCartBtn');

      if (cartDrawerHtml && cartDrawerToggleHtml) {
        document.getElementById('Cart-Drawer').replaceWith(cartDrawerHtml);
        document.getElementById('cart-drawer-toggle').replaceWith(cartDrawerToggleHtml);
        if (addToCartBtn) addToCartBtn.classList.remove('loading');
        document.body.classList.add('open-cc');
        cartDrawerHtml.classList.add('active');
        
        document.dispatchEvent(new CustomEvent('cart-drawer:open'));
      }
    } catch (error) {
      console.error('Cart Update Error:', error);
      const btn = document.getElementById('cross_addToCartBtn');
      if (btn) btn.classList.remove('loading');
    }
  }

  /**
   * 2. Multi-Product Add to Cart
   */
  const initAddToCart = function() {
    const btn = document.getElementById('cross_addToCartBtn');
    if (!btn) return;

    btn.addEventListener('click', async () => {
      const wrapper = document.querySelector('#cross-merchandising');
      const products = wrapper ? [...wrapper.querySelectorAll('.thb-product-detail')] : [];
      
      btn.classList.add('loading');
      
      const items = products.map((el) => ({
        id: el.querySelector('input[name=id]')?.value,
        quantity: el.querySelector('input[name=quantity]')?.value || 0
      })).filter(item => item.id && item.quantity > 0);

      if (!items.length) {
        btn.classList.remove('loading');
        return;
      }

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (res.ok) updateCartDrawer();
      } catch (err) {
        btn.classList.remove('loading');
      }
    });
  };

  /**
   * 3. Variant Navigation Logic
   * Ensures clicking a product title takes you to the specific selected variant.
   */
  const initVariantLinks = function() {
    document.querySelectorAll('.cross-merch-product-link').forEach((link) => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const baseUrl = this.dataset.productUrl;
        const detail = this.closest('.thb-product-detail');
        const script = detail?.querySelector('script[type="application/json"]');
        const selectedVariantId = detail?.querySelector('input[name="id"]')?.value;
        const selectedColorInput = detail?.querySelector('.product-form__input--color input:checked');
        const selectedColor = selectedColorInput?.value?.trim();
        const targetUrl = new URL(baseUrl, window.location.origin);
        
        if (selectedColor) {
          targetUrl.searchParams.set('selected-color', selectedColor);
        }

        if (selectedVariantId) {
          targetUrl.searchParams.set('variant', selectedVariantId);
          window.location.href = targetUrl.toString();
          return;
        }

        if (!script) {
          window.location.href = targetUrl.toString();
          return;
        }

        try {
          const variants = JSON.parse(script.textContent);
          const match = variants.find((variant) => {
            return String(variant.id) === String(selectedVariantId);
          }) || variants[0];

          if (match) {
            targetUrl.searchParams.set('variant', match.id);
          }

          window.location.href = targetUrl.toString();
        } catch (err) {
          window.location.href = targetUrl.toString();
        }
      });
    });
  };

  /**
   * 4. Instant Color Synchronization
   * Syncs colors across sections without simulating clicks or causing delays.
   */
  function performInstantSync(colorValue) {
    if (!colorValue) return;
    const cleanColor = colorValue.trim();

    // Target all cross-merch product blocks
    const targets = document.querySelectorAll('#cross-merchandising .thb-product-detail');
    
    targets.forEach(block => {
      // Find the radio input that matches the color name exactly
      const radio = block.querySelector(`input[type="radio"][value="${cleanColor}"]`);
      
      if (radio && !radio.checked) {
        radio.checked = true;
        // Dispatch 'change' so Shopify updates the variant image/price immediately
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  const initColorSync = function() {
    // 1. Listen for manual changes on the main product section
    const mainInputs = document.querySelectorAll('.product-section .product-form__input--color input');
    
    mainInputs.forEach(input => {
      input.addEventListener('change', (e) => {
        performInstantSync(e.target.value);
      });
    });

    // 2. IMMEDIATE SYNC (On Page Load)
    // Works for direct variant links (?variant=...)
    const activeInput = document.querySelector('.product-section .product-form__input--color input:checked');
    const activeLabelText = document.querySelector('.product-section .product-form__input--color .form__label__value');

    const initialColor = activeInput ? activeInput.value : (activeLabelText ? activeLabelText.textContent : null);

    if (initialColor) {
      // We use requestAnimationFrame to ensure the DOM is ready for the first paint
      window.requestAnimationFrame(() => {
        performInstantSync(initialColor);
      });
    }
  };

  // Run all initializations
  initAddToCart();
  initVariantLinks();
  initColorSync();
})();
